import React, { useEffect } from 'react'
import cn from 'classnames'

import Close from 'assets/svg/close.svg'

import './Modal.scss'

const KEYCODES_ESC = 27

const Modal = (props) => {
    const show = props.open ? 'modal' : 'none'
    const closeBtn = props.closeBtn ? 'modal__close' : 'none'

    function closeOutside(event) {
        if (
            props.closeBtn &&
            props.closeOnClickOutside &&
            event.target.classList.contains('modal')
        ) {
            props.onClick()
        }
    }

    useEffect(() => {
        document.body.classList.add('overflow-hidden')

        return () => document.body.classList.remove('overflow-hidden')
    }, [])

    useEffect(() => {
        function handleKeyDown(event) {
            if (
                props.closeBtn &&
                props.closeOnEsc &&
                event.keyCode === KEYCODES_ESC
            ) {
                props.onClick()
            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [])

    return (
        <div className={show} onClick={closeOutside}>
            <div className={cn('modal__content', props.className)}>
                <img
                    id={props.idCloseBtn}
                    className={closeBtn}
                    src={Close}
                    alt="Close Alelo"
                    onClick={props.onClick}
                />
                {props.children}
            </div>
        </div>
    )
}

Modal.defaultProps = {
    closeOnClickOutside: true,
    closeOnEsc: true,
    onClick: () => {}
}

export default Modal
